export const locale = {
  GENERAL: {
    LOADING: "กำลังโหลด...",
    ONLINE: "ออนไลน์",
    ADD: "เพิ่ม",
    EDIT: "แก้ไข",
    DELETE: "ลบ",
    SUBMIT: "ดำเนินการ",
    SAVE: "บันทึก",
    CANCEL: "ยกเลิก",
    DISCARD: "ยกเลิก",
    SEARCH: "ค้นหา",
    PLEASE_SELECT: "กรุณาเลือก...",
    ALLOWED_FILE_TYPE: "ไฟล์ที่อนุญาติ:",
    SELECTED: "ข้อมูลที่เลือก",
    EXPORT: "ส่งออกข้อมูล",
    ACTIONS: "ดำเนินการ",
    VIEW: "ดูรายละเอียด",
    PLEASE_WAIT: "กรุณารอ...",
    ALL: "ทั้งหมด",
    BAHT_SYMBOL: "฿",
    BAHT: "บาท",
    MONTH: {
      JAN: "ม.ค.",
      FEB: "ก.พ.",
      MAR: "มี.ค.",
      APR: "เม.ย.",
      MAY: "พ.ค.",
      JUN: "มิ.ย.",
      JUL: "ก.ค.",
      AUG: "ส.ค.",
      SEP: "ก.ย.",
      OCT: "ต.ค.",
      NOV: "พ.ย.",
      DEC: "ธ.ค.",
    },
    CONFIRM: "ยืนยัน",
    ADDRESS_PLACEHOLDER: "บ้านเลขที่ ซอย หมู่บ้าน หมู่ ถนน",
    BACK: "ย้อนกลับ",
    SAVE_AND_CONTINUE: "บันทึกและทำต่อ",
    CLEAR_FORM: "ล้างข้อมูล",
    DOWNLOAD: "ดาวน์โหลด",
    COPY_LINK: "คัดลอกลิงค์",
    COPY_LINK_SUCCESS: "คัดลอกลิงค์สำเร็จ",
    REQUIRE_FILED: "กรุณาระบุ",
    NO_DATA_EXPORT: "ไม่พบข้อมูลสำหรับส่งออก",
  },
  POPUP_MESSAGE: {
    LOGIN_SUCCESS: "ลงชื่อเข้าใช้ระบบสำเร็จ",
    SAVE_SUCCESS: "บันทึกข้อมูลสำเร็จ",
    SUCCESS_MESSAGE_CONFIRM: "ตกลง",
    ERROR_MESSAGE_CONFIRM: "ลองใหม่อีกครั้ง",
  },
  SWAL: {
    CONFIRM: {
      SAVE: {
        TITLE: "ยืนยันการบันทึกข้อมูล",
        MESSAGE: "ต้องการบันทึกข้อมูลหรือไม่",
        SUBMIT: "ยืนยัน",
      },
      DELETE: {
        TITLE: "ยืนยันการลบข้อมูล",
        MESSAGE: "ต้องการลบข้อมูลหรือไม่",
        SUBMIT: "ยืนยัน",
      },
    },
  },
  PAGINATION: {
    SHOW_FROM_TO_OF: "รายการที่ {from} ถึง {to} จาก {total} รายการ",
  },
  DATE_PERIOD: {
    TODAY: "วันนี้",
    LAST_SEVEN_DAYS: "7 วันที่ผ่านมา",
    LAST_MONTH: "เดือนที่แล้ว",
    LAST_THREE_MONTHS: "สามเดือนที่แล้ว",
    LAST_SIX_MONTHS: "หกเดือนที่แล้ว",
    LAST_YEAR: "ปีที่แล้ว",
    THIS_WEEK: "สัปดาห์นี้",
    THIS_MONTH: "เดือนนี้",
    THIS_YEAR: "ปีนี้",
  },
  COMPANY: {
    NAME: "มหาวิทยาลัยเนชั่น",
  },
  TRANSLATOR: {
    LANGUAGE: "ภาษา",
    ENGLISH: "อังกฤษ",
    THAILAND: "ไทย",
  },
  FOOTER: {
    ABOUT: "เกี่ยวกับ",
    TERM: "เงื่อนไข",
    CONTACT: "ติดต่อ",
    CONTACT_US: "ติดต่อเรา",
  },
  MENU: {
    DASHBOARD: {
      TITLE: "ข้อมูลสรุป",
    },
    SETTINGS: {
      TITLE: "ตั้งค่า",
      PEOPLE: {
        TITLE: "ผู้คน",
        PEOPLE_LIST: "ผู้คน",
        PEOPLE_DETAIL: "รายละเอียดผู้คน",
      },
      PROJECT: {
        TITLE: "ประเภทโคงการ",
        LIST: "ประเภทโคงการ",
        DETAIL: "รายละเอียดประเภทโคงการ",
      },
      DIVISION: {
        TITLE: "คณะ",
        LIST: "คณะ",
        DETAIL: "รายละเอียดคณะ",
      },
      PREFIX: {
        TITLE: "คำนำหน้า",
        LIST: "คำนำหน้า",
        DETAIL: "รายละเอียดคำนำหน้า",
      },
      TEACHER_APPLY: {
        TITLE: "อาจารย์ผู้รับสมัคร",
        LIST: "อาจารย์ผู้รับสมัคร",
        DETAIL: "รายละเอียดอาจารย์ผู้รับสมัคร",
      },
      SYSTEM_CONFIG: {
        TITLE: "ตั้งค่าระบบ",
      },
    },
  },
  VIEW: {
    DASHBOARD: {
      TITLE: "แผงควบคุม",
    },
  },
  COMPONENT: {
    DASHBOARD: {
      ORDER_THIS_MONTH: {
        TITLE: "คำสั่งซื้อเดือนนี้",
        TO_GOAL: "ถึงเป้าหมาย",
        NO_ANY_ORDER: "ไม่มีคำสั่งซื้อ",
      },
      AVERAGE_DAILY_SALES: {
        TITLE: "เฉลี่ยยอดขายรายวัน",
      },
      NEW_CUSTOMER_THIS_MONTH: {
        TITLE: "ลูกค้าใหม่ในเดือนนี้",
        NO_TODAY_HERO: "ไม่มีฮีโร่วันนี้",
        TODAY_HERO: "ฮีโร่วันนี้",
        NO_ANY_NEW_CUSTOMER: "ไม่มีลูกค้าใหม่",
      },
      TOP_TREE_BEST_SELLER: {
        TITLE: "3 อันดับสินค้าขายดีประจำเดือนนี้",
        NO_ANY_PRODUCT: "ยังไมีมีสินค้าขายดี",
      },
      SALES_THIS_MONTHS: {
        TITLE: "ยอดขายในเดือนนี้",
        SUB_TITLE: "ยอดขายจากทุกช่องทาง",
      },
    },
  },
  USER: {
    TITLE: "ผู้ใช้ระบบ",
    EMAIL: "อีเมล",
    NAME: "ชื่อ",
    SURNAME: "นาทสกุล",
    ROLE: "บทบาท",
    ACCOUNT_SETTING: "การตั้งค่าบัญชี",
    MY_PROFILE: "ข้อมูลของฉัน",
    MY_STATEMENTS: "รายรับของฉัน",
    SIGN_OUT: "ออกจากระบบ",
  },
  DASHBOARD: {
    TITLE: "แผงควบคุม",
    FILTER: "ตัวกรองข้อมูล",
    ENROLL_DATE: "วันที่สมัคร",
    STUDY_LEVEL: "ระดับการศึกษา",
    ENROLL_START_DATE: "วันที่สมัครตั้งแต่",
    ENROLL_END_DATE: "ถึง",
    CURRICULUM: "หลักสูตร",
  },
  AUTH: {
    GENERAL: {
      PRIVACY: "ความเป็นส่วนตัว",
      ABOUT: "เกี่ยวกับ",
      CONTACT: "ติดต่อ",
      CONTACT_US: "ติดต่อเรา",
      TERM: "Terms",
      EMAIL: "อีเมลล์",
      PASSWORD: "รหัสผ่าน",
      NAME: "Name",
      SURNAME: "Surname",
      AGREE: "I Agree the",
      TERM_AND_CONDITIONS: "terms and conditions",
      CONTINUE: "ลงชื่อเข้าใช้",
      PLEASE_WAIT: "Please wait...",
    },
    LOGIN: {
      TITLE: "ยินดีต้องรับสู่ Landing Page Nation",
      NEW_HERE: "ยังไม่มีชื่อผู้ใช้ ใช่หรือไม่",
      CREATE_ACCOUNT: "สร้างบัญชีผู้ใช้",
      FORGOT_PASSWORD: "ลืมรหัสผ่าน",
      CONTINUE_WITH_FACEBOOK: "เข้าระบบด้วย Facebook",
      FB_LOGIN_FAILED: "ลงชื่อเข้าใช้ด้วย Facebook ไม่สำเร็จ",
      FB_LOGIN_FAILED_DESC: "ผู้ใช้ยกเลิกการเข้าสู่ระบบ หรือไม่ได้รับอนุญาต",
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUBMIT: "Submit",
      CANCEL: "Cancel",
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUBMIT: "Submit",
      CANCEL: "Cancel",
    },
    INPUT: {
      EMAIL: "อีเมลล์",
      FULL_NAME: "Full name",
      PASSWORD: "รหัสผ่าน",
      CONFIRM_PASSWORD: "Confirm Password",
      USERNAME: "Username",
    },
  },
  SETTING: {
    PEOPLE: {
      TITLE: "รายละเอียดบุคคล",
      PICTURE: "รูป",
      PREFIX: "คำนำหน้า",
      NAME: "ชื่อ",
      SURNAME: "นามสกุล",
      EMAIL: "อีเมลล์",
      ROLE: "บทบาท",
      PASSWORD: "รหัสผ่าน",
      PASSWORD_CONFIRM: "ยืนยันรหัสผ่าน",
      PASSWORD_MUST_MATCH: "รหัสผ่านจะต้องตรงกัน",
      PEOPLE: "ผู้คน",
      LAST_LOGIN_DATE: "ลงชื่อเข้าใช้ล่าสุด",
      JOINED_DATE: "เข้าร่วมเมื่อ",
      SIGN_IN_METHOD: "วิทีลงชื่อเข้าใช้งาน",
      ENTER_NEW_EMAIL: "ใส่อีเมลล์ใหม่",
      DEACTIVATE_ACCOUNT_TITLE: "ปิดการใช้งานชื่อบัญชีน",
      DEACTIVATE_ACCOUNT: "ปิดการใช้งานชื่อบัญชีนี้",
      CONFIRM_DEACTIVATE_ACCOUNT: "ฉันยืนยันที่จะปิดการใช้งานชื่อบัญชีนี้",
      DEACTIVATED_SUCCESS: "ปิดการใช้งานชื่อบัญชีนี้ เสร็จสิ้น",
      CHANGE_EMAIL: "เปลี่ยนอีเมลล์",
      UPDATE_EMAIL: "เปลี่ยนอีเมลล์",
      RESET_PASSWORD: "รีเซ็ตรหัสผ่าน",
      UPDATE_PASSWORD: "เปลี่ยนรหัสผ่าน",
      NEW_PASSWORD: "รหัสผ่านใหม่",
      CONFIRM_NEW_PASSWORD: "ยืนยันรหัสผ่านใหม่",
    },
    ROLE: {
      ENROLLER: "ผู้สมัคร",
      ENROLLER_DESCRIPTION: "เหมาะสำหรับผู้ที่เป็นผู้สมัคร",
      ADMIN: "ผู้ดูแลระบบ",
      ADMIN_DESCRIPTION: "เหมาะสำหรับผู้ที่เป็นผู้ดูแลระบบ",
    },
    PROJECT: {
      TITLE: "ประเภทโคงการ",
      NAME: "ชื่อ",
    },
    DIVISION: {
      TITLE: "คณะ",
      NAME: "ชื่อ",
    },
    PREFIX: {
      TITLE: "คำนำหน้า",
      NAME: "ชื่อ",
      OTHER: "อื่นๆ",
    },
    TEACHER_APPLY: {
      TITLE: "อาจารย์ผู้รับสมัคร",
      NAME: "ชื่อ",
      OTHER: "ช่องทางอื่นๆ",
    },
    SYSTEM_CONFIG: {
      TITLE: "ตั้งค่าระบบ",
      COMPANY_CONFIG: "เกี่ยวกับบริษัท",
      APP_LOGO: "โลโก้",
      COMPANY_NAME: "ชื่อบริษัท",
      COMPANY_ID_NUMBER: "เลขประจำตัวผู้เสียภาษี",
      COMPANY_ADDRESS_1: "ที่อยู่บริษัท บรรทัดที่ 1",
      COMPANY_ADDRESS_2: "ที่อยู่บริษัท บรรทัดที่ 2",
      COMPANY_EMAIL: "อีเมลบริษัท",
      COMPANY_PHONE_NUMBER: "เบอร์โทรศัพท์บริษัท",
      SALE_CONFIG: "เกี่ยวกับการขาย",
    },
  },
  UPLOAD: {
    DROP_FILE_HERE: "ลากไฟล์มาวางที่นี่ หรือ คลิก เพื่ออัพโหลด",
    VIDEO_LIMIT: "ไฟล์วิดีโอขนาดไม่เกิน 1gb",
    DOCUMENT_LIMIT: "ไฟล์เอกสาร .pdf ขนาดไม่เกิน 2mb",
  },
  ENROLL: {
    TITLE: "ลงทะเบียนรับคำปรึกษา",
    BACHELOR_DESCRIPTION: "ระดับปริญญาโท หลักสูตรบริหารธุรกิจ (MBA.)",
    MBA_DESCRIPTION: "ระดับปริญญาโท หลักสูตรบริหารธุรกิจ (MBA.)",
    MED_DESCRIPTION: "ระดับปริญญาโท หลักสูตรการบริหารการศึกษา (ME.d)",
    PREFIX: "คำนำหน้า",
    NAME: "ชื่อ",
    SURNAME: "นามสกุล",
    EMAIL: "อีเมล",
    MOBILE: "เบอร์โทรศัพท์",
    SEND_DATA: "ส่งข้อมูล",
    ID_NUMBER: "เลขที่บัตรประชาชน 13 หลัก",
    LINE_ID: "Line Id",
    WEIGHT: "น้ำหนัก (กิโลกรัม)",
    HEIGHT: "ส่วนสูง (เซนติเมตร)",
    EDUCATION: "วุฒิการศึกษา",
    INSTITUTE: "ชื่อสถานศึกษา",
    STUDY_PLAN: "แผนการเรียน",
    GPA: "เกรดเฉลี่ย (GPA หรือ GPAX)",
    PROJECT: "ประเภทโครงการที่ต้องการสมัคร",
    DIVISION: "คณะที่ต้องการสมัคร",
    TEACHER_APPLY: "อาจารย์ผู้รับสมัคร",
    FILE_UPLOAD: "เอกสารการสมัคร",
    UPLOAD:
      "อัพโหลดเอกสารการสมัคร (สำเนาบัตรประชาชน, สำเนาทะเบียนบ้าน, ผลการเรียน, รูปถ่ายขนาด 1 นิ้ว และหลักฐานการชำระเงินค่าสมัครเรียน) รวมเอกสารเป็น PDF ไฟล์เดียวกัน",
    CREATED_AT: "สมัครเมื่อ",
    PLEASE_UPLOAD_FILE: "กรุณาเลือกไฟล์อัพโหลด",
    CONTACT_TIME: "เวลาติดต่อ",
    PROVINCE: "จังหวัด",
    CONFIRM: "ยืนยันเพื่อให้ข้อมูลเพื่อให้ทางมหาวิทยาลัยติดต่อกลับ",
  },
};
